import type { TransactionType } from "@/interface/common/location_inteface";
import { AppointmentType, TransactionTypeIcons } from "@/helper/transaction_types";

export class TransactionTypeServices {
  async fetchTransaction(): Promise<TransactionType[]> {
    try {
      return transactionTypes;
    } catch (e) {
      throw Error;
    }
  }
}

export const transactionTypes: TransactionType[] = [
  {
    label: "Import Availability",
    icon: TransactionTypeIcons.PUI,
    value: AppointmentType.ImportPickUp,
    isActive: true,
    variant: "filled",
    appearance: "neutral",
    disabled: false
  },
  {
    label: "Export Enquiry",
    icon: TransactionTypeIcons.DOE,
    value: AppointmentType.ExportDropOff,
    isActive: false,
    variant: "filled",
    appearance: "neutral",
    disabled: false
  },
  {
    label: "Container Event History",
    icon: TransactionTypeIcons.CEH,
    value: AppointmentType.ContainerEventHistory,
    isActive: false,
    variant: "filled",
    appearance: "neutral",
    disabled: false
  },

  {
    label: "Vessel Schedule",
    icon: TransactionTypeIcons.VS,
    value: AppointmentType.VesselSchedule,
    isActive: false,
    variant: "filled",
    appearance: "neutral",
    disabled: false
  }
];
